module.exports = __webpack_public_path__ + "img/54.7.Chla.fbd4a3cd.png";